import React from "react";
import cx from "clsx";
import { Share } from "lucide-react";
import { Text } from "./Text";
import { Button } from "./Button";

export function ShareButton() {
  return (
    <div className="flex">
      <Button variant="ghost">
        <Share className={cx("min-h-5 min-w-5 text-primary")} />
        <Text className="ml-2">Поделиться</Text>
      </Button>
    </div>
  );
}
